import axios from 'axios';
import appConfig from '@/config';
import { getCookie } from '@/utils/auth/authService';
const BASE_URL = appConfig.api.base;


export function getSummary(){
  const url = `${BASE_URL}/overview/summary`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  // let merchantId = this.$store.state.authUser.merchantId
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
      
    }
  })
  
}

export function getPaymentSummary(currencyId){
  const url = `${BASE_URL}/overview/payments/summary?currencyId=${currencyId}`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId,
    }
  })
  
}

export function globalSearch(filter){
  const url = `${BASE_URL}/globalSearch`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  // let merchantId = this.$store.state.authUser.merchantId
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    params: {
      search: filter,
    }
  })

}


// WEBPACK FOOTER //
// ./src/utils/overview/overviewService.js